import React, { memo } from "react";

import { Pill } from "src/design-system/Pill";

export const PlaceholderPillRenderer: React.FC = memo(() => {
  return (
    <div className="flex h-full w-full items-center break-all border-0 p-2">
      <Pill fontType="code" size="sm" variant="gray">
        <Pill.Text>is any</Pill.Text>
      </Pill>
    </div>
  );
});
